import React from 'react';
import { ServerStatus } from '../../../types/models/server-status';
import { Button, Popup } from 'semantic-ui-react';
import styled from 'styled-components';
import StatusLed from '../../../components/widgets/status-led';
import { lightColors } from '../../../themes/colors';

const ListItem = styled.li`
  display: grid;
  grid-template-columns: 1fr 3fr;
  align-items: center;
  span.led {
    cursor: pointer;
    display: inline-block;
    height: 13px;
    width: 13px;
    border-radius: 50%;
  }
  span.led-red {
    background-color: ${lightColors.red};
  }
  span.led-green {
    background-color: ${lightColors.green};
  }
  .ui.button {
    background-color: transparent;
    padding: 10px;
  }
`;
interface ServerStatusProps {
  status: ServerStatus;
}

export function ServerStatusItem(props: ServerStatusProps) {
  return (
    <>
      <ListItem>
        <Popup
          content={props.status.errorDetail}
          header={props.status.name}
          trigger={
            <Button>
              <StatusLed status={props.status.status} />
            </Button>
          }
        />
        <span>{props.status.name}</span>
      </ListItem>
    </>
  );
}
